var url = "//"+window.location.hostname+"/api/";
if(window.location.hostname == 'localhost'){
    url = "http://"+window.location.hostname+":3000/api/";
}
import _ from 'lodash';
import axios from 'axios';

// Cache para armazenar requisições em andamento
const pendingRequests = new Map();

// Função para gerar uma chave única para a requisição
const generateRequestKey = (url, params) => {
    return `${url}-${JSON.stringify(params)}`;
};

var API = {
    url:url,
    events: url+'Events',
    checkCupom: url+'Events/:id/checkcupom/:code',
    eventProduct: url+'Events/:id/products',
    placeOrder: url+'Orders/place',
    saveOrder: url+'Orders/save',
    loadOrderInfo: url+'Orders/info',
    register: url+'Clients',
    login: url+'Clients/login',
    logmeAsUser: url+'Clients/logmeasuser',
    logout: url+'Clients/logout',
    reset: url+'Clients/reset',
    setpassword: url+'Clients/me/setNewPassword',
    resetPasswordForCPF: url+'Clients/resetPasswordForCPF',
    updateUser: url+'Clients/atualiza',
    currentUser: url+'Clients/me',
    myRegistrations: url+'Clients/me/myregistrations',
    registrationsById: url+'Clients/me/registrationsbyid/:id',
    allRegistrations: url+'Clients/me/allregistrations/:id',
    userExist: url+'Clients/exist',
    purchaseProduct: url+'Clients/me/myregistrations/:id',
    savePurchase: url+'PurchaseProducts/save',
    markPurchaseAsPayed: url+'PurchaseProducts/:id/markAsPayed/',
    markPurchaseAsCanceled: url+'PurchaseProducts/:id/markAsCanceled/',
    markPurchaseAsNotCanceled: url+'PurchaseProducts/:id/markAsNotCanceled/',
    listCupoms: url+'Events/:id/listCupoms',
    addCupom: url+'Events/:eventId/Cupoms',
    deleteCupom: url+'Events/:eventId/Cupoms/:id',

    // GPX upload feature (team-owner endpoints)
    gpxInitiateUpload: url+'GpxUploads/initiateUpload',
    gpxFinalizeUpload: url+'GpxUploads/finalizeUpload',
    gpxListForTeam: url+'GpxUploads/listForTeam/:teamId',
    gpxDeleteOwn: url+'GpxUploads/deleteOwn/:id',

    // GPX admin endpoints
    gpxAdminList: url+'GpxUploads/adminList',
    gpxAdminGet: url+'GpxUploads/adminGet/:id',
    gpxAdminTeamList: url+'GpxUploads/adminTeamList',
    gpxAdminTeamGet: url+'GpxUploads/adminTeamGet/:teamId/:competitionId',
    gpxAdminTeamReview: url+'GpxUploads/adminTeamReview',
    gpxAdminSetThresholds: url+'GpxUploads/adminSetThresholds',
    gpxAdminReviewAction: url+'GpxUploads/adminReviewAction',
    gpxAdminReprocess: url+'GpxUploads/reprocess/:id',
    gpxAdminReprocessAll: url+'GpxUploads/reprocessAllForCompetition/:competitionId',
    gpxAdminDelete: url+'GpxUploads/adminDelete/:id',
    gpxGetEventConfig: url+'GpxUploads/eventConfig/:eventId',
    gpxSetEventConfig: url+'GpxUploads/setEventConfig',
    gpxListCompetitionTracks: url+'GpxUploads/adminListCompetitionTracks/:eventId',
    gpxSetCompetitionTrack: url+'GpxUploads/adminSetCompetitionTrack',
    gpxSetCompetitionRaceTimes: url+'GpxUploads/adminSetCompetitionRaceTimes',
    gpxCopyCompetitionTrack: url+'GpxUploads/adminCopyCompetitionTrack',

    // CompetitionTrack (reference route)
    competitionTrackUpsert: url+'CompetitionTracks/upsertWithGeoJSON',
    competitionTrackGet: url+'CompetitionTracks/byCompetition/:competitionId',

    // Resultados + certificados
    resultsAdminList: url+'RaceResults/adminListResults/:eventId',
    resultsAdminSet: url+'RaceResults/adminSetResult',
    resultsAdminRecompute: url+'RaceResults/adminRecompute/:eventId',
    certificateConfigGet: url+'RaceResults/certificateConfig/:eventId',
    certificateConfigSet: url+'RaceResults/setCertificateConfig',
    certificateGet: url+'RaceResults/certificate/:purchaseProductId',
}



export default {
    ...API,

    getUrl:function(key,options){
        var url = _.get(API,key,url);   
        if( !_.isObject(options) )
            options = {id:options}
        _.each(options,(v,k)=>{
            var regex = new RegExp(`:${k}`, 'ig');
            url = url.replace(regex,v)
        })
        return url;
    },

    parseURL:function(url){
        url = _.trim(url)
        if( url.indexOf("http") == 0 || url.indexOf("//") == 0 ){
            return url
        }else{
            url = this.url+"/"+url
            return url.replace(/([^:])\/\/*/g,'$1/')
        }
    },

    getHeaderAuthentication:function(){
        let token = getToken();
        let header = { 'Content-Type':'application/json' }
        if(_.has(token,'id'))
            header['Authorization'] = _.get(token,'id')
        return header
    },


    getJSONAsync:async function(url,params={},withoutAuthorization=false,cb=null){
        if( _.has(API,url)){
            url = this.getUrl(url,params);
        }else{
            url = this.parseURL(url)
        }
        let headers = this.getHeaderAuthentication();
        if(withoutAuthorization) headers={};
        try{
            let res = await axios.get(url,{params:params,headers});
            return res.data;
        }catch(e){
            console.error(e)
            let message = (e.response.statusText || e.message);
            return {...e.response,error:true,message};
        }
    },


    getJSON:async function(url,params={},cb=null){
        
        if( _.has(API,url)){
            url = this.getUrl(url,params);
        }else{
            url = this.parseURL(url)
        }
        let headers = this.getHeaderAuthentication();
        var promise = axios.get(url,{params:params,headers});


        if(_.isFunction(cb)){
            promise.then( (response)=>cb(response.data,null) )
            promise.catch( (erro)=>cb(null,erro) )
        }
        
        return promise
    },

    postJSON:async function(url,param={},cb=null){
        if( _.has(API,url)){
            url = this.getUrl(url,param);
        }else{
            url = this.parseURL(url)
        }
        let headers = this.getHeaderAuthentication();
        var promise = axios.post(url,param,{headers});
        if(_.isFunction(cb)){
            promise.then( (response)=>cb(response.data,null) )
            promise.catch( (erro)=>cb(null,erro) )
        }
        return promise
    },

    deleteJSON:async function(url,param={},cb=null){
        if( _.has(API,url)){
            url = this.getUrl(url,param);
        }else{
            url = this.parseURL(url)
        }
        let headers = this.getHeaderAuthentication();
        // axios.delete(url, config) — só 2 argumentos. Headers precisam ir
        // DENTRO do config (o 3º arg era ignorado e o DELETE saía sem
        // Authorization → 401).
        var promise = axios.delete(url,{headers, data:param});
        if(_.isFunction(cb)){
            promise.then( (response)=>cb(response.data,null) )
            promise.catch( (erro)=>cb(null,erro) )
        }
        return promise
    },

    postJSONAsync:async function(url,params={},cb=null){
        if( _.has(API,url)){
            url = this.getUrl(url,params);
        }else{
            url = this.parseURL(url)
        }

        const requestKey = generateRequestKey(url, params);
        
        if (pendingRequests.has(requestKey)) {
            return pendingRequests.get(requestKey);
        }

        try{
            let headers = this.getHeaderAuthentication();
            
            const promise = axios.post(url,params,{headers}).then(response => {
                pendingRequests.delete(requestKey);
                return response.data;
            }).catch(error => {
                pendingRequests.delete(requestKey);
                throw error;
            });

            pendingRequests.set(requestKey, promise);
            
            return await promise;
        }catch(e){
            console.error(e)
            let message = (e.response && e.response.statusText) || e.message;
            return {...e.response,error:true,message};
        }
    },

    patchJSONAsync:async function(url,params={},cb=null){
        if( _.has(API,url)){
            url = this.getUrl(url,params);
        }else{
            url = this.parseURL(url)
        }

        const requestKey = generateRequestKey(url, params);
        
        if (pendingRequests.has(requestKey)) {
            return pendingRequests.get(requestKey);
        }

        try{
            let headers = this.getHeaderAuthentication();
            
            const promise = axios.patch(url,params,{headers}).then(response => {
                pendingRequests.delete(requestKey);
                return response.data;
            }).catch(error => {
                pendingRequests.delete(requestKey);
                throw error;
            });

            pendingRequests.set(requestKey, promise);
            
            return await promise;
        }catch(e){
            let message = (e.response && e.response.statusText) || e.message;
            return {...e.response,error:true,message};
        }
    },

    putJSONAsync:async function(url,params={},cb=null){
        if( _.has(API,url)){
            url = this.getUrl(url,params);
        }else{
            url = this.parseURL(url)
        }

        const requestKey = generateRequestKey(url, params);
        
        if (pendingRequests.has(requestKey)) {
            return pendingRequests.get(requestKey);
        }

        try{
            let headers = this.getHeaderAuthentication();
            
            const promise = axios.put(url,params,{headers}).then(response => {
                pendingRequests.delete(requestKey);
                return response.data;
            }).catch(error => {
                pendingRequests.delete(requestKey);
                throw error;
            });

            pendingRequests.set(requestKey, promise);
            
            return await promise;
        }catch(e){
            let message = (e.response && e.response.statusText) || e.message;
            return {...e.response,error:true,message};
        }
    },

}



const getToken = ()=>{
    let token = localStorage.token
    if(token)
        token = JSON.parse(token);

    return token;
}

const saveToken = (token)=>{
    localStorage.token = JSON.stringify(token)
}



